

<div class="main-header">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12">
                <div class="logo">
                    <a routerLink="/home">
                    <img [src]="getImageSrc()" class="header-logo" alt="logo">
                    </a>
                    <div class="mob-menu-opt">
                        <a (click)="staticModal.show()">
                            <i class="fa-solid fa-bars"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-10 col-md-6 col-sm-6 col-xs-6">
                <div class="side-menu-opts">
                    <div class="menu">
                        <ul>
                            <li>
                                <a routerLink="/home"><img src="assets/image/flight.png" width="25" height="25" alt="flight-menu">
                                    {{"Flight" | translate}}</a>
                            </li>
                            <li>
                                <a routerLink="/home"><img src="assets/image/hotel.png" width="25" height="25"
                                        alt="hotel-menu">{{"Hotel" | translate}}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="user-menu">
                        <ul>
                          <li>
                            <a href="tel:{{ sitePhone }}" target="_blank">
                              <img src="assets/image/wp.png" width="30" height="30" alt="">{{ sitePhone }}
                            </a>
                          </li>
                            <li>
                                <div class="cuurancy-opts">
                                    <div class="selected-currancy" (click)="dropdownOpen()">
                                      {{defaultDisplayCurrency | translate}}
                                      <img src="assets/image/red-down.png" width="10" class="mx-1" alt="">
                                    </div>
                                    <div class="cuurancy-content" *ngIf="contentdropdown">
                                      <ul>
                                        <!-- Skip rendering the first li when i is 0 -->
                                        <ng-container *ngFor="let arr of currencies; let i = index">
                                          <li *ngIf="i !== 0"
                                              [class.active]="i === colorvariable || arr.code === defaultDisplayCurrency"
                                              (click)="changeCode(arr); dropdownOpen()">
                                            <b>{{arr.code | translate}}</b>{{arr.name | translate}}
                                          </li>
                                        </ng-container>
                                      </ul>
                                    </div>
                                  </div>

                            </li>
                            <li>
                                <a href="#"><img src="assets/image/wallet.png" width="20" height="20" alt="">{{"My points" | translate}}</a>
                            </li>
                            <!-- <li>
                                <a href="#"><img src="assets/image/user.png" width="20" height="20" alt="">{{"Abdelsalam" | translate}}</a>
                            </li> -->
                            <li>
                                <a *ngIf="!global?.isUserLogin" role="button" (click)="openModal()"><img src="assets/image/user.png" width="20" height="20" alt="">{{"Sign In" | translate}}</a>
                                <a *ngIf="global?.isUserLogin" role="button" routerLink="customer/my-profile"><img src="assets/image/user.png" width="20" height="20" alt="">{{"Hello," | translate}} {{global.loginUserName}}</a>
                            </li>
                            <li class="me-0">
                                <div class="direction-switcher">
                                    <form *ngIf="myForm" [formGroup]="myForm" class="language-otps">
                                        <div class="form-group">
                                          <div class="btn-group" btnRadioGroup formControlName="radio">
                                            <label btnRadio="ar" (click)="toggleTextDirection(true)" class="btn btn-primary mb-0 arabic-txt">ع</label>
                                            <label btnRadio="en" (click)="toggleTextDirection(false)" class="btn btn-primary mb-0">EN</label>
                                          </div>
                                        </div>
                                      </form>
                                  </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal right fade mobile-sidebar-open" bsModal #staticModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
            <!-- <img [src]="getImageSrc()" class="modal-title pull-left" alt="logo"> -->
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="staticModal.hide()">
          <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
      </div>
      <div class="modal-body">

      </div>
    </div>
  </div>
</div>

<app-download-application></app-download-application>
